namespace SPA
{
	export namespace Organization
	{
		export namespace gui
		{
			export class NewDepartmentEntry extends AbstractEntry
			{
				private Company: Wollmilch.CompanyObject;

				public constructor( obj: Wollmilch.CompanyObject, orga: OrgaTree )
				{
					super( orga );

					this.Company = obj;

					this.clearTitle();
					this.addTitle( 'Neue Abteilung anlegen' );
				}

				public rebuild( root?: ui.base.BaseHTMLElement<HTMLElement> | JQuery<HTMLElement> ): NewDepartmentEntry
				{
					super.rebuild( root );

					const form: ui.Form.Form = new ui.Form.Form(
						{
							action: 'organization/new/Department',
							method: 'POST',
							notSwitchable: true,
							classes: [
								'form-horizontal'
							],
							css:
							{
								'display': 'flex',
								'flex-direction': 'column'
							},
							submit: ( _method: ui.Form.FormMethod, _url: string, parameter: ui.Form.IFormParameter ): void =>
							{
								new Wollmilch.AJAX(
									{
										method: _method,
										url: _url,
										data: parameter,
										on:
										{
											success: ( jsonText: string ): void =>
											{
												const result = Wollmilch.jsonize( jsonText );

												if ( result === null )
												{
													app.addNotify(
														{
															body: [
																'Es ist ein Fehler bei der Verarbeitung der Anfrageantwort aufgetreten,' +
																' bitte versuchen Sie es später erneut!'
															],
															title: [ 'Schwerwiegender Fehler' ],
															context: 'danger',
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													return;
												}

												if ( !result.success )
												{
													app.addNotify(
														{
															body: [
																'Die Anfrage ist fehlgeschlagen, bitte versuchen Sie es erneut.'
															],
															title: [ 'Anfragefehler' ],
															context: 'danger',
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													return;
												}

												app.addNotify(
													{
														body: [ 'Abteilung erfolgreich angelegt.' ],
														title: [ 'Erfolg!' ],
														context: "success",
														timeout: Number(app.getConfigValue("ToastTimeout"))
													}
												);

												const data = result.data as Wollmilch.DepartmentObject;

												new Wollmilch.AJAX(
													{
														method: 'POST',
														url: 'organization/link/' + this.Company.ID + '/' + data.ID,
														data:
														{
															function: 'PartOf'
														},
														on:
														{
															success: () =>
															{
																const link = Wollmilch.jsonize( jsonText );

																if ( link === null || !link.success )
																{
																	app.addNotify(
																		{
																			body: [
																				'Abteilung konnte nicht mit der Firma ' + this.Company.Name + ' verbunden werden.'
																			],
																			title: [ 'Schwerwiegender Fehler' ],
																			context: 'danger',
																			timeout: Number(app.getConfigValue("ToastTimeout"))
																		}
																	);

																	return;
																}
																app.addNotify(
																	{
																		context: "success",
																		body: [ 'Abteilung erfolgreich mit der Firma ' + this.Company.Name + ' verbunden.' ],
																		timeout: Number(app.getConfigValue("ToastTimeout")),
																		title: [ 'Erfolg!' ]
																	}
																);
																$('html').trigger('reloadOrgaTree');
															}
														}
													},
													Wollmilch.AJAXCallbase_e.APIV1
												).send();
											}
										}
									},
									Wollmilch.AJAXCallbase_e.APIV1
								).send();
							}
						}
					);

					form.rebuild( this );

					form.append(
						ui.$$.p()
							.text( 'Bitte füllen Sie alle Felder aus, welche mit einem Sternchen (*) gekennzeichnet sind' )
							.addClass( 'form-required text-danger small-caps' )
					);

					this.buildBasicInfo( form );

					const l_BtnBar = new ui.base.BaseHTMLElement( 'div' );

					new ui.base.Button(
						$('<i class="fa fa-save"></i> <span>Speichern</span>'),
						{
							context: 'success',
							attr:
							{
								type: 'submit'
							}
						}
					).rebuild( l_BtnBar );

					form.append( l_BtnBar );

					return this;
				}

				private buildBasicInfo( _form: ui.Form.Form ): void
				{
					const basics: ui.base.BaseHTMLElement = new ui.base.BaseHTMLElement( 'div' );

					basics.css( { 'flex-grow': '1' } );

					basics.appendTo( _form );

					basics.append(
						ui.$$.h( 4, 'Abteilung-Daten' )
					);

					this.AddInput(
						basics,
						_form,
						[
							{
								size: {
									xs: 12,
									sm: 12,
									md: 8,
									lg: 8
								},
								input: new ui.Form.TextInput(
									null,
									{
										name: 'Identifier',
										noautocomplete: true,
										placeholder: 'Abkürzung der Abteilung',
										required: true
									}
								),
								label: 'Abkürzung*'
							}
						]
					);

					this.AddInput(
						basics,
						_form,
						[
							{
								size: {
									xs: 12,
									sm: 12,
									md: 8,
									lg: 8
								},
								input: new ui.Form.TextInput(
									null,
									{
										name: 'Name',
										noautocomplete: true,
										placeholder: 'Name der neuen Abteilung',
										required: true
									}
								),
								label: 'Name*'
							}
						]
					);
				}
			}
		}
	}
}
